<template>
  <b-modal
    v-model="showModal"
    size="lg"
    id="crtcreator-post-type-modal"
    :title="edited.id ? 'Edit post type' : 'Add post type'"
    :ok-title="isFormLoading ? 'Saving...' : 'Save'"
    :ok-disabled="isFormLoading"
    cancel-variant="outline-secondary"
    @ok="onSubmit($event)"
  >
    <b-form>
      <b-form-group label="Name" label-for="post-type-name">
        <b-form-input id="post-type-name" v-model="edited.name" placeholder="Name" />
        <small v-if="errors.name" class="text-danger">{{ errors.name }}</small>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
import {
  BForm, BFormGroup, BFormInput, BModal,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'
import { toastFailure, toastSuccess } from '@/libs/toastification'

const defaults = () => ({
  id: null,
  name: '',
})

export default {
  components: {
    BForm, BFormGroup, BFormInput, BModal,
  },
  props: {
    record: { type: Object, default: null },
    clickDate: { type: Date, default: null },
  },
  data() {
    return {
      showModal: false,
      isFormLoading: false,
      edited: defaults(),
      errors: {},
    }
  },
  watch: {
    clickDate() {
      this.errors = {}
      this.edited = this.record
        ? { id: this.record.id, name: this.record.name || '' }
        : defaults()
      this.showModal = true
    },
  },
  methods: {
    ...mapActions({
      addItem: 'crtcreator/postTypes/addItem',
      updateItem: 'crtcreator/postTypes/updateItem',
    }),
    async onSubmit(event) {
      event.preventDefault()
      this.errors = {}
      if (!String(this.edited.name || '').trim()) {
        this.errors.name = 'Name is required'
        return
      }
      this.isFormLoading = true
      const payload = { name: this.edited.name }
      try {
        if (this.edited.id) {
          await this.updateItem({ id: this.edited.id, payload })
          toastSuccess('Successfully updated')
        } else {
          await this.addItem(payload)
          toastSuccess('Successfully added')
        }
        this.showModal = false
      } catch (e) {
        toastFailure('Failed to save')
      } finally {
        this.isFormLoading = false
      }
    },
  },
}
</script>
